module.exports = "app-boletos {\n  margin-top: -30px;\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/boletos/boletos.component.scss
// module id = ./src/app/modules/dashboard/components/boletos/boletos.component.scss
// module chunks = main